import { render, staticRenderFns } from "./ClassContractList.vue?vue&type=template&id=39387c3e"
import script from "./ClassContractList.vue?vue&type=script&lang=js"
export * from "./ClassContractList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports